import { getCapacities } from "../../modules/utilities"
import { CATEGORY } from "../../modules/constants"
import { notEmpty } from "../../modules/utilities"
import { getRoleFromBasics } from "../../components/layout/NexusTableFunctions"
import HOOK from "../../components/hooks"

// Filters items for nexus table
export const getFilteredItems = props => {
    // console.log('getFilteredItems props:', props)
    let connection = {}
    const { checkboxes, connections, isCompany, items, maxLseData, showSecondDegree } = props
    const filteredItems = []

    items.filter(i => i.level > 0).forEach(item => {
        const showConnection = !showSecondDegree
            ? item.level === 1
            : item.level === 2 && (isCompany
                ? item.entity.category === CATEGORY.COMPANY
                : item.entity.category === CATEGORY.PERSON)

        if (showConnection) {
            connection = showSecondDegree
                ? {}
                // Company and officer are always 'parent' and 'child' respectively.
                // So, if we are the company tab (eg '3I GROUP PLC') all the items will be officers.
                // Thus, we want the connections where the item.id (eg '001_BANSZKY') matches the connection childId
                // (eg connections[000]: {parentId: '000_3I_GROU', childId: '001_BANSZKY', )
                // If we are on person tab, all items are companies and we want the connections where the childId matches,
                // NOT the item.id (eg '000_3I_GROU' which will have connections to lots of people), but the item.lConnectId
                : isCompany // Company tab
                    // @ts-ignore
                    ? Object.filter(connections, c => c.childId === item.id && c.parentId === item.lConnectId)
                    // @ts-ignore
                    : Object.filter(connections, c => c.childId === item.lConnectId && c.parentId === item.id)

            if (notEmpty(connection)) {
                const capacities = getCapacities(connection, item.id)
                capacities.officer.forEach(role => {
                    if (!!(checkboxes[HOOK.TENSE] & role.tenseBit)
                        && !!(checkboxes[HOOK.POSITION] & role.typeBit)
                        && !!(checkboxes[HOOK.EXEC] & getBit(role.position.exec))
                        && !!(checkboxes[HOOK.INDP] & getBit(role.position.independent))
                    ) {
                        filteredItems.push(createItemClone({ item, role, hasConnection: true }))
                        // console.log('filteredItems[filteredItems.length-1]:', filteredItems[filteredItems.length - 1])
                    }
                })

                capacities.psc.forEach(role => {
                    if (!!maxLseData && !!(checkboxes[HOOK.TENSE] & role.tenseBit) && !!(checkboxes[HOOK.POSITION] & role.position.typeBit)) {
                        role.psc = true
                        filteredItems.push(createItemClone({ item, role, hasConnection: true }))
                    }
                })
            }
            else if (showSecondDegree) {
                filteredItems.push(item)
            }
            else { // no connection - PSC to second degree!!
                item.roles.forEach(roleDescription => {
                    const role = getRoleFromBasics({ roleDescription, item })
                    filteredItems.push(createItemClone({ item, role, hasConnection: false }))
                })
            }
        }
    })

    return filteredItems
}

const createItemClone = ({ item, role, hasConnection }) => {
    return {
        entity: item.entity,
        hasConnection,
        index: item.index,
        level: item.level,
        role: basicRoleProps(role),
        via: item.via,
        kinship: item.kinship,
    }
}

const basicRoleProps = role => ({
    compensationGBP: role.compensationGBP,
    days: role.days,
    from: role.from,
    future: role.future,
    position: positionProps(role.position),
    psc: role.psc,
    roleDescription: role.roleDescription,
    tense: role.tense,
    until: role.until,
})

const positionProps = position => ({
    exec: getBit(position?.exec),
    indp: getBit(position?.independent),
    title: position.title,
    type: position.type,
    typeBit: position.typeBit,
})

// Returns 1 if bool is true, 2 if false, or 4 if null
const getBit = bool => bool == true ? 1 : bool === false ? 2 : 4

